import React from 'react';
import { Tag, Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useTranslation } from '@refinedev/core';
import { ChangeReq } from '@/api/types/getOnePost';

interface ChangeRequestBadgeProps {
  changeRequests?: ChangeReq[];
  onClick?: () => void;
}

export const ChangeRequestBadge: React.FC<ChangeRequestBadgeProps> = ({
  changeRequests = [],
  onClick,
}) => {
  const { translate } = useTranslation();

  if (!changeRequests.length) return null;

  return (
    <Tooltip title={translate('changeRequests.pending.tooltip')}>
      <Tag
        icon={<WarningOutlined />}
        color="warning"
        className="cursor-pointer"
        onClick={onClick}
      >
        {changeRequests.length} {translate('changeRequests.pending')}
      </Tag>
    </Tooltip>
  );
};
